module.exports = __webpack_public_path__ + "media/images/heart-c8661f75df3b1bb880a0843c8933e71d.svg";